import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './shared/services/theme.service';
import { Toast } from './shared/components/toast/toast';
import { Preloader } from './shared/components/preloader/preloader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, Preloader],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('frontend');
}
